import React from "react";
import closeIcon from "assests/img/close-icon.svg";

type AppletModalComponentProps = {
    show: boolean;
    close: () => void;
    children: JSX.Element;
    header: string;
    overlayWidthInPercentage: number
};

const ARSSidePanel = (props: React.PropsWithChildren<AppletModalComponentProps>
) => {

    const overlayClasses =
        "tw-absolute tw-inset-0  tw-z-40 tw-h-full tw-w-full";
    const menuClasses = props?.show
        ? `tw-absolute tw-top-0 tw-right-0 tw-h-full tw-max-h-full tw-overflow-auto tw-bg-white tw-z-50  tw-shadow-lg tw-w-[${props.overlayWidthInPercentage}%]`
        : "tw-hidden";

    return (
        <div className="tw-h-[calc(100vh-60px)] tw-fixed tw-top-0 tw-left-0 tw-w-full tw-z-40 tw-mt-16 ">
            <div className={overlayClasses} onClick={() => { }} />
            <div className={menuClasses}>
                <div
                    className={`tw-flex tw-justify-between tw-items-center  tw-pb-2 tw-pt-4 tw-pr-2 tw-pl-2 tw-sticky tw-top-0 tw-bg-white tw-z-10`}
                >
                    <div className="tw-ml-2 tw-font-bold">
                        {props.header}
                    </div>
                    <div className="tw-mr-2 tw-cursor-pointer" onClick={props?.close}>
                        <img
                            className="promotion-close-icon"
                            src={closeIcon}
                            alt="Close icon"
                        />
                    </div>
                </div>
                <div>
                    {props?.children}
                </div>
            </div>

        </div>
    );
};

export default ARSSidePanel;


